import { RootState } from '../store';
import { Approvals } from './slice';

export const getApprovals = (state: RootState): Approvals => state.nft.approvals;

export const getIsAllApproved = (state: RootState): boolean => {
  let isApproved = true;
  Object.keys(state.nft.approvals.data).forEach((e) => {
    if (state.nft.approvals.data[e] === false) isApproved = false;
  });
  return isApproved;
};

export const selectNumTokens = (state: RootState): number | undefined => state.nft.numTokens;
